import { useRef } from "react";
import styled from "styled-components";
import BigNumber from "bignumber.js";
import FarmRow from "./FarmRow";
import { Box } from "@mui/material";

interface FarmsTableProps {
  pools: any;
  userDataLoaded: boolean;
  account: string;
}

export interface DeserializedPool {
  totalStaked?: BigNumber;
  stakingLimit?: BigNumber;
  stakingLimitEndBlock?: number;
  profileRequirement?: {
    required: boolean;
    thresholdPoints: BigNumber;
  };
  userData?: {
    allowance: BigNumber;
    stakingTokenBalance: BigNumber;
    stakedBalance: BigNumber;
    pendingReward: BigNumber;
  };
}

const StyledTable = styled.div`
  scroll-margin-top: 64px;
  background : #00202F;
  border-radius : 30px;
  > div:not(:last-child) {
    border-bottom: 2px solid #000B22;
  }
  `;

const StyledTableBorder = styled.div`
  padding: 1px 1px 3px 1px;
  margin-bottom: 50px;
  background-size: 400% 400%;
`;


const FarmsTable: React.FC<FarmsTableProps> = ({
  pools,
  userDataLoaded,
  account,
}) => {
  // console.log(account)

  const tableWrapperEl = useRef<HTMLDivElement>(null);
  return (
    <>
      {pools.length !== 0 ?
        <StyledTableBorder>
          <StyledTable id="pools-table" role="table" ref={tableWrapperEl}>
            {pools.map((pool, index) => (

              <FarmRow
                key={pool.vaultKey ?? pool.sousId}
                pool={pool}
                index={index}
                account={account}
                userDataLoaded={userDataLoaded}
              />

            ))}
          </StyledTable>
        </StyledTableBorder>
        :
        <Box sx={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '16px', fontWeight: '400', lineHeight: '1.5' }}>
          No Farms
        </Box>
      }
    </>
  );
};

export default FarmsTable;
